import React from "react";
import {
  ToastContainer as SpectrumToastContainer,
  type ToastContainerProps,
} from "@react-spectrum/s2";

const SpectrumToast = SpectrumToastContainer as React.FC<ToastContainerProps>;

/**
 * S2 types `ToastContainer` as returning `ReactNode`, which fails TS2786 under
 * @types/react 18 (“not a valid JSX element”). This wrapper is typed as `React.FC`.
 */
export function ToastContainer(props: ToastContainerProps) {
  return <SpectrumToast {...props} />;
}

export type { ToastContainerProps };
